import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-629f9826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caseEdit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0);",
  class: "back-link"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" })
], -1))
const _hoisted_3 = { class: "df jc-right" }
const _hoisted_4 = { class: "link" }
const _hoisted_5 = { class: "caseEdit__input" }
const _hoisted_6 = { class: "caseEdit__input" }
const _hoisted_7 = { class: "caseEdit__input" }
const _hoisted_8 = { class: "caseEdit__input" }
const _hoisted_9 = { class: "caseEdit__input" }
const _hoisted_10 = { class: "caseEdit__input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_drive_input = _resolveComponent("drive-input")!
  const _component_drive_files = _resolveComponent("drive-files")!
  const _component_app_label_input = _resolveComponent("app-label-input")!
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!
  const _component_drive_info = _resolveComponent("drive-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, {
      "custom-title": _ctx.title,
      countPadding: ""
    }, {
      "top-left": _withCtx(() => [
        _hoisted_2
      ]),
      "top-right": _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$localize('drive.done.button')), 1)
        ])
      ]),
      _: 1
    }, 8, ["custom-title"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_drive_input, {
        title: _ctx.$localize('edit.case.title'),
        placeholder: _ctx.$localize('edit.case.title.placeholder'),
        hideBorder: _ctx.HIDE_BORDER.BOTTOM,
        disabled: ""
      }, null, 8, ["title", "placeholder", "hideBorder"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_drive_input, {
        title: _ctx.$localize('edit.case.description.title'),
        placeholder: _ctx.$localize('edit.case.description.placeholder'),
        hideBorder: _ctx.HIDE_BORDER.BOTTOM,
        disabled: ""
      }, null, 8, ["title", "placeholder", "hideBorder"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_drive_files, {
        files: [],
        title: _ctx.$localize('edit.case.media.type.photo'),
        hideBorder: _ctx.HIDE_BORDER.BOTTOM,
        "skeleton-amount": _ctx.photoSkeletons,
        isPhoto: "",
        disabled: ""
      }, null, 8, ["title", "hideBorder", "skeleton-amount"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_drive_files, {
        files: [],
        title: _ctx.$localize('edit.case.media.type.file'),
        hideBorder: _ctx.HIDE_BORDER.BOTTOM,
        "skeleton-amount": _ctx.fileSkeletons,
        disabled: ""
      }, null, 8, ["title", "hideBorder", "skeleton-amount"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_drive_ui_wrapper, {
        title: _ctx.$localize('edit.case.labels'),
        hideBorder: _ctx.HIDE_BORDER.BOTTOM
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_label_input, {
            skeleton: "",
            focus: ""
          })
        ]),
        _: 1
      }, 8, ["title", "hideBorder"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_drive_info, {
        created: 'Mon DD, YY, HH:MM:SS PM/AM',
        updated: 'Mon DD, YY, HH:MM:SS PM/AM'
      })
    ])
  ]))
}